import React from 'react';
import { PromptConfirmation, ValidationProps } from 'ui';
import { ExtraFooterButton } from 'ui/common/select/types';
import { STATE } from 'app/constants';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { useOptions } from 'app/components/options-handler/hooks';
import { SelectSingleHierarchy } from 'app/area/shared/translated-components';
import { ImportMappingsTranslation } from 'app/area/import-mappings/constants';
import { usePromptOnChange } from 'app/area/import-mappings/list-items/components/prompt-on-change';

interface FilterDetailsPickerProps {
  componentId: string;
  label: string;
  codetableId?: number;
  endpoint: string;
  shouldPrompt: boolean;
  valueItem: ComplexValue<number>;
  loadOptionsParams?: LoadOptions;
  optionsParams?: { [key: string]: boolean | string[] };
  searchRequired?: boolean;
  translation: ImportMappingsTranslation;
  validation?: ValidationProps;
  onChange: (value: ComplexValue<number>) => void;
  extraFooterButton?: ExtraFooterButton;
}

export const FilterDetailsPicker: React.FC<FilterDetailsPickerProps> = ({
  componentId, label, codetableId, endpoint, shouldPrompt, valueItem,
  loadOptionsParams, optionsParams, searchRequired, translation,
  onChange, extraFooterButton
}) => {

  const {
    options,
    fetching,
    loadOptions,
    onLoadOptions
  } = useOptions(STATE.importMappings, componentId, endpoint, codetableId, {
    loadOptionsParams, optionsParams
  });

  const { displayPrompt, onPromptedChange, onContinue, onHide } = usePromptOnChange(shouldPrompt, onChange);

  return <>
    {shouldPrompt && displayPrompt
      && <PromptConfirmation
        title={translation.cancel_changes}
        description={translation.are_you_sure}
        continueText={translation.undo_all}
        cancelText={translation.go_back}
        onContinue={onContinue}
        onCancel={onHide} />}
    <div className="col-lg-6 col-sm-12">
      <SelectSingleHierarchy
        componentId={componentId}
        className={undefined}
        label={{ text: label }}
        valueItem={valueItem}
        descriptionAllLevels={true}
        onChange={onPromptedChange}
        searchRequired={searchRequired}
        extraFooterButton={extraFooterButton}
        options={options}
        loadOptions={loadOptions}
        fetching={fetching}
        onLoadOptions={onLoadOptions}
        placeholder={translation.search} />
    </div>
  </>;
};
